//@flow
import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import PaymentAuthentications from './PaymentAuthentications';
import type { StateProps } from './PaymentAuthentications';
import type { StateType } from '../../../modules/reducers';
import { paymentAuthenticationsSelector } from '../../../modules/Payment/selector';
import { fetchPaymentAuthentications } from '../../../modules/Payment/actions';
import Navigation from '../../../lib/navigation';

const mapStateToProps = (state: StateType): StateProps => ({
  paymentAuthentications: paymentAuthenticationsSelector(state),
});

const mapDispatchToProps = dispatch => ({
  fetchPaymentAuthentications: () => dispatch(fetchPaymentAuthentications()),
  navigateToPaymentAuthorizationResult: navigationParams => {
    Navigation.dispatch(
      CommonActions.navigate({
        name: 'PaymentAuthorizationResult',
        params: {
          notificationMaxSendDate: navigationParams.notificationMaxSendDate,
          notificationOuid: navigationParams.notificationOuid,
          processName: navigationParams.processName,
          stripeIntentId: navigationParams.stripeIntentId,
          stripeRedirectUrl: navigationParams.stripeRedirectUrl,
        },
      })
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentAuthentications);
